import { styled } from '@material-ui/core';
import { BODY1 } from '@tuunetech/tuune-components';

export const UnderlinedBODY1 = styled(BODY1)({
  textDecoration: 'underline',
});
